import React from 'react';
import useTranslations from '../../../../hooks/useTranslations';
import SelectUsersEngine from '../engine/SelectUsersEngine';
import ActionEmailTemplateEditorEngine from '../engine/ActionEmailTemplateEditorEngine';

const ShareWithView = props => {
  const t = useTranslations();
  return (
    <>
      <SelectUsersEngine
        {...props}
        update={props.updateRoot}
        useMultiUserSelect
        withAdmins
      />
      <ActionEmailTemplateEditorEngine
        templateId={props.templateId}
        setTemplateId={props.setTemplateId}
        containerCSS="align-self: end;"
      />
    </>
  );
};

export default ShareWithView;
